export default __webpack_public_path__ + "static/media/Bounty Hunter's Crossbow.168273a8.jpg";